<template>
  <div>
    <el-dialog
      title="Log Create Shipment"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-escape="false"
      :close-on-click-modal="false"
      @closed="onHidden"
      :before-close="onHidden"
      custom-class="loadingDiv"
      center>
      <div style="margin-bottom: 10px">
        <el-row>
          <el-col :span="6">
            <el-input v-model="filters[0].value" placeholder="ค้นหา Order Number"></el-input>
          </el-col>
        </el-row>
      </div>
      <template v-if="statusCheck === 'pass'">
      <data-tables
        :data="orderDetailTable"
        style="width: 100%"
        :filters="filters"
        class="dataTable">
        <el-table-column label="Create shipment Date" width="250">
          <div
            class="text-md-left"
            slot-scope="scope">
            {{scope.row.create | dayjs('format', 'YYYY-MM-DD HH:mm:ss')}}</div>
        </el-table-column>
        <el-table-column prop="orderNumber" label="orderNumber" width="130">
          <div class="text-md-left" slot-scope="scope">
            <a href @click.stop.prevent="LogDetail(scope.row.orderNumber)">{{scope.row.orderNumber}}</a>
          </div>
        </el-table-column>
        <el-table-column prop="trackingNumber" label="trackingNumber" width="170"></el-table-column>
        <el-table-column prop="courierProviderName" label="courierName" width="120"></el-table-column>
        <el-table-column prop="errorCode" label="errorCode" width="100"></el-table-column>
        <el-table-column prop="errorMessage" label="errorMessage"></el-table-column>
      </data-tables>
      </template>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">ยกเลิก</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    name: 'LogDetailCreateShipment',
    props: {
        dialogShow: {
            type: Boolean,
            default: false
        },
        orderDetail: {
            type: Array,
            default: null
        },
        status: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            dialogVisible: false,
            orderDetailTable: [],
            orderListFail: {},
            filters: [
                {
                    prop: 'orderNumber',
                    value: ''
                }
            ],
            statusCheck: ''
        }
    },
    watch: {
        dialogShow (val) {
            if (val) {
                this.dialogVisible = true
            }
        },
        status (val) {
            if (val) {
                this.statusCheck = val
            }
        },
        orderDetail (val) {
            if (val) {
                this.orderDetailTable = val
            }
        }
    },
    methods: {
        onHidden (done) {
            this.filters[0].value = ''

            this.$emit('closeModal')
            if (done !== undefined) {
                done()
            }
        },
        LogDetail (val) {
            let route = this.$router.resolve({
                path: `/oms/logOrder/LogOrderDetail`,
                query: { orderId: val }
            })
            window.open(route.href, '_blank')
        }
    }
}
</script>

<style lang="scss">
.break-word {
  overflow-wrap: break-word;
}
.dataTable {
  .el-table .cell {
    font-size: 16px;
  }
}
</style>
